exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.contributor-badge-cw[data-v-4a694e27]::before {\n  border-radius: 100%;\n  border: 10px solid transparent;\n}\n", ""]);

// exports
